import { Navigation, Keyboard } from "swiper/modules";
import { Swiper } from "swiper";
import "swiper/css";
import "swiper/css/navigation";

function iacoModal(smoothScroll) {
  const modal = document.querySelector("#modal");
  if (!modal) return;

  const scrollContainer = document.querySelector("[data-scroll-container]");

  const elements = {
    gallery: modal.querySelector(".modal__gallery"),
    video: modal.querySelector(".modal__video"),
    legend: modal.querySelector(".modal__legend"),
    text: modal.querySelector(".modal__text"),
    prevBtn: modal.querySelector(".modal__button-prev"),
    nextBtn: modal.querySelector(".modal__button-next"),
  };

  // State management
  let isGalleryMode = false;
  let initialSlideIndex = 0;
  let scrollPosition = 0;
  let gallerySwiper = null;

  // Single consolidated click handler
    const handleClick = (e) => {
        const trigger = e.target.closest(
            ".video-modal-trigger, .gallery-modal-trigger",
        );

        if (trigger) {
            const isGalleryTrigger = trigger.classList.contains(
                "gallery-modal-trigger"
            );

            if (isGalleryTrigger) {
                const postType = trigger.closest("[data-post-type]")?.dataset.postType;

                if (postType !== "photo_gallery") {
                    return;
                }
            }

            isGalleryMode = isGalleryTrigger;
            initialSlideIndex = trigger.dataset.slideIndex
                ? parseInt(trigger.dataset.slideIndex, 10)
                : 0;

            setModalData(trigger);
            openModal();
            return;
        }

    const videoWrap = e.target.closest(".slide-video");
    if (videoWrap) {
      const playBtn = videoWrap.querySelector(".slide-video__play");
      const video = videoWrap.querySelector("video");
      if (video && playBtn) {
        if (video.paused) {
          playBtn.style.display = "none";
          video.play().catch(() => {
            playBtn.style.display = "";
          });
          video.addEventListener("ended", () => {
            playBtn.style.display = "";
          }, { once: true });
        } else {
          video.pause();
          playBtn.style.display = "";
        }
      }
      return;
    }

    // Prevent close when clicking navigation buttons (Swiper handles them)
    if (
      e.target.closest(".modal__button-prev") ||
      e.target.closest(".modal__button-next")
    ) {
      return;
    }

    // Close modal
    if (
      !e.target.closest(".modal__wrapper") ||
      e.target.closest(".modal__close")
    ) {
      if (modal.classList.contains("active")) {
        closeModal();
      }
    }
  };

  // Keyboard support
  const handleKeydown = (e) => {
    if (!modal.classList.contains("active")) return;
    if (e.key === "Escape") closeModal();
  };

  document.addEventListener("click", handleClick);
  document.addEventListener("keydown", handleKeydown);

  function initGallerySwiper(initialSlide = 0) {
    destroyGallerySwiper();

    const swiperEl = elements.gallery.querySelector(".modal-gallery-swiper");
    if (!swiperEl) return;

    gallerySwiper = new Swiper(swiperEl, {
      modules: [Navigation, Keyboard],
      autoHeight: true,
      initialSlide: initialSlide,
      navigation: {
        nextEl: elements.nextBtn,
        prevEl: elements.prevBtn,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
      on: {
        slideChangeTransitionStart: () => {
          elements.gallery.querySelectorAll("video").forEach((v) => v.pause());
          elements.gallery.querySelectorAll(".slide-video__play").forEach((btn) => {
            btn.style.display = "";
          });
        },
      },
    });
  }

  function destroyGallerySwiper() {
    if (gallerySwiper) {
      gallerySwiper.destroy(true, true);
      gallerySwiper = null;
    }
  }

  function setModalData(trigger) {
    const id = trigger.dataset.modalTriggerId;
    if (!id) {
      console.warn("Modal trigger missing data-modal-trigger-id");
      return false;
    }

    hideAllContent();

    const setContent = (element, selector) => {
      if (!element) return false;

      const source = document.querySelector(selector);
      if (source) {
        element.innerHTML = source.innerHTML;
        element.style.display = "block";
        return true;
      } else {
        console.warn(`Modal content not found: ${selector}`);
        return false;
      }
    };

    const isGallery = id.includes("gallery");

    if (isGallery && elements.gallery) {
      document.querySelector(".modal__wrapper").classList.add("modal--gallery");
      setContent(elements.gallery, `[data-modal-gallery='${id}']`);
    } else if (elements.video) {
      setContent(elements.video, `[data-modal-video='${id}']`);
    }

    setContent(elements.legend, `[data-modal-legend='${id}']`);
    setContent(elements.text, `[data-modal-text='${id}']`);

    return true;
  }

  function hideAllContent() {
    if (elements.gallery) elements.gallery.style.display = "none";
    if (elements.video) elements.video.style.display = "none";
  }

  function openModal() {
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    modal.classList.add("active");
    modal.setAttribute("aria-hidden", "false");

    if (smoothScroll) {
      smoothScroll.stop();
    }

    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = "100%";
    document.body.style.left = "0";
    document.body.style.right = "0";

    if (scrollContainer) {
      scrollContainer.style.overflow = "hidden";
      scrollContainer.style.position = "fixed";
      scrollContainer.style.width = "100%";
      scrollContainer.style.height = "100vh";
    }

    // Show/hide navigation buttons
    if (elements.prevBtn && elements.nextBtn) {
      if (isGalleryMode) {
        elements.prevBtn.style.display = "flex";
        elements.nextBtn.style.display = "flex";
      } else {
        elements.prevBtn.style.display = "none";
        elements.nextBtn.style.display = "none";
      }
    }

    const btns = modal.querySelector(".modal__btns");
    const elementsToAnimate = [
      elements.gallery,
      modal.querySelector(".modal__content"),
    ];

    if (btns) {
      btns.style.opacity = "0";
      btns.style.transform = "scale(0.95)";
      setTimeout(() => {
        btns.style.transition = "transform 0.15s ease, opacity 0.15s ease";
        btns.style.transform = "scale(1)";
        btns.style.opacity = "1";
      }, 10);
    }

    elementsToAnimate.forEach((el) => {
      if (el && el.style.display !== "none") {
        el.style.opacity = "0";
        el.style.transform = "scale(0.95)";

        setTimeout(() => {
          el.style.transition = "transform 0.3s ease, opacity 0.3s ease";
          el.style.transform = "scale(1)";
          el.style.opacity = "1";
        }, 10);
      }
    });

    // Initialize swiper after DOM is ready
    if (isGalleryMode) {
      setTimeout(() => initGallerySwiper(initialSlideIndex), 50);
    }

    const video = elements.video?.querySelector("video");
    if (video) {
      video.play().catch((err) => {
        console.warn("Autoplay prevented:", err);
      });
    }
  }

  function closeModal() {
    const btns = modal.querySelector(".modal__btns");

    if (btns) {
      btns.style.transition = "transform 0.15s ease, opacity 0.15s ease";
      btns.style.transform = "scale(0.95)";
      btns.style.opacity = "0";
    }

    const elementsToAnimate = [
      elements.gallery,
      modal.querySelector(".modal__content"),
    ].filter((el) => el && el.style.display !== "none");

    const video = elements.video?.querySelector("video");
    if (video) {
      video.pause();
      video.currentTime = 0;
    }

    // Pause any playing gallery videos
    elements.gallery?.querySelectorAll("video").forEach((v) => {
      v.pause();
      v.currentTime = 0;
    });

    const finish = () => {
      destroyGallerySwiper();

      modal.classList.remove("active");
      modal.setAttribute("aria-hidden", "true");

      Object.values(elements).forEach((el) => {
        if (el && el !== elements.prevBtn && el !== elements.nextBtn) {
          el.innerHTML = "";
          el.style.display = "none";
        }
      });

      if (btns) {
        btns.style.opacity = "";
        btns.style.transform = "";
        btns.style.transition = "";
      }

      document
        .querySelector(".modal__wrapper")
        .classList.remove("modal--gallery");

      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.style.left = "";
      document.body.style.right = "";

      if (scrollContainer) {
        scrollContainer.style.overflow = "";
        scrollContainer.style.position = "";
        scrollContainer.style.width = "";
        scrollContainer.style.height = "";
      }

      window.scrollTo(0, scrollPosition);

      if (smoothScroll) {
        smoothScroll.start();
        setTimeout(() => {
          smoothScroll.update();
        }, 100);
      }
    };

    if (elementsToAnimate.length === 0) {
      finish();
      return;
    }

    elementsToAnimate.forEach((el) => {
      el.style.transition = "transform 0.3s ease, opacity 0.3s ease";
      el.style.transform = "scale(0.95)";
      el.style.opacity = "0";
    });

    setTimeout(finish, 300);
  }

  return function destroy() {
    document.removeEventListener("click", handleClick);
    document.removeEventListener("keydown", handleKeydown);
    destroyGallerySwiper();
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    document.body.style.left = "";
    document.body.style.right = "";
    if (scrollContainer) {
      scrollContainer.style.overflow = "";
      scrollContainer.style.position = "";
      scrollContainer.style.width = "";
      scrollContainer.style.height = "";
    }
  };
}

export { iacoModal };
